export const handleError = (error: any, defaultMessage: string) => {

    let errorMessage = "";
  
    if (error?.response?.data?.error?.message && error?.response?.data?.error?.details) {
      errorMessage = `${error?.response?.data?.error?.message}  ${error?.response?.data?.error?.details}`;
    } else if (error?.response?.data?.error?.message) {
      errorMessage = error?.response?.data?.error?.message;
    } else {
      errorMessage = defaultMessage;
    }
  
    return {
      success: false,
      response: {
        success: false,
        error: { message: errorMessage }
      }
    };
  };